import type { FC } from 'react';

export const CryptocurrencyCardLoading: FC = () => {
  return (
    <div className="bg-background-primary rounded-2xl border border-border-disabled p-5 flex flex-col shadow-background-hover shimmer">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-[40px] h-[40px] rounded-lg bg-background-disabled" />
        <div className="flex-1">
          <div className="h-4 w-24 mb-2 bg-background-disabled rounded" />
          <div className="h-3 w-32 bg-background-disabled rounded" />
        </div>
      </div>

      <div className="border-t border-border-disabled pt-5 flex-1 flex flex-col gap-7">
        {[1, 2, 3, 4, 5].map((index) => {
          return (
            <div
              key={`${index}-loading`}
              className="flex items-center justify-between"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className="size-8 rounded-full bg-background-disabled shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="h-4 w-24 bg-background-disabled rounded" />
                </div>
              </div>
              <div className="flex flex-col items-end gap-2 shrink-0 ml-2">
                <div className="h-4 w-16 bg-background-disabled rounded" />
                <div className="h-3 w-12 bg-background-disabled rounded" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
